import React from "react";
import {Modal} from "antd";
import PropTypes from "prop-types";
import {ModalBody} from "./ui/modal-body";
import Text from "antd/lib/typography/Text";
import {ArrowLeftOutlined} from "@ant-design/icons";
import {SendCodeButton} from "./ui/send-code-button";
import {EditEmailButton} from "./ui/edit-email-button";
import {CardItem} from "../../pages/applications/application/Card";

export const ChangeEmail = ({uuId, email, setApplication}) => {
	const localStorageKey = `clickCount_${uuId}`;

	const [isModalOpen, setIsModalOpen] = React.useState(false);
	const [showCodeInput, setShowCodeInput] = React.useState(false);

	const [clickCount, setClickCount] = React.useState(() => {
		const storedCount = localStorage.getItem(localStorageKey);
		return storedCount ? parseInt(storedCount, 10) : 0;
	});

	const showModal = () => {
		setIsModalOpen(true);
	};

	const handleCancel = () => {
		setIsModalOpen(false);
	};

	return (
		<>
			<CardItem
				name='Էլ. հասցե'
				value={(
					<div className='customer-email-container'>
						<Text ellipsis>{email || '-'}</Text>
						<SendCodeButton
							uuId={uuId}
							email={email}
							showModal={showModal}
							clickCount={clickCount}
							setClickCount={setClickCount}
							setApplication={setApplication}
							localStorageKey={localStorageKey}
						/>
						<EditEmailButton showModal={showModal}/>
					</div>
				)}
			/>
			<Modal
				width={600}
				footer={null}
				destroyOnClose
				maskClosable={false}
				visible={isModalOpen}
				onCancel={handleCancel}
				className='edit-customer-email-modal'
				afterClose={() => setShowCodeInput(false)}
				title={showCodeInput ? (
					<div style={{display: 'flex', alignItems: 'center', gap: 8}}>
						<ArrowLeftOutlined
							onClick={() => setShowCodeInput(false)}
						/>
						Խմբագրել Էլ. հասցեն
					</div>
				) : "Խմբագրել Էլ. հասցեն"}
			>
				<ModalBody
					uuId={uuId}
					email={email}
					showModal={showModal}
					clickCount={clickCount}
					showCodeInput={showCodeInput}
					setClickCount={setClickCount}
					setApplication={setApplication}
					setIsModalOpen={setIsModalOpen}
					localStorageKey={localStorageKey}
					setShowCodeInput={setShowCodeInput}

				/>
			</Modal>
		</>
	)
};

ChangeEmail.propTypes = {
	uuId: PropTypes.string.isRequired,
	email: PropTypes.string.isRequired,
	setApplication: PropTypes.func.isRequired,
};